const $ = jQuery
const ajaxUrl = $('#ajaxurl').val()

const bindEvents = () => {
  $('.timeline-item').on('click', handlerTimeline)
}

const handlerTimeline = () => {
  const that = event.target

  $('.timeline-item').removeClass('active');
  $(that).addClass('active');

  $(".ano").tagit("removeAll");
  $('.ano').val($(that).html());
  $(".ano").tagit("createTag", $(that).html());
  $('.search-filter .submit').trigger('click');
  $('.head').removeClass('active');
  $('.body').removeClass('active');
}

const getFilters = () => {
  $.post(ajaxUrl, {
    action: 'it_get_filters'
  }, function( response ) {
    if( typeof response === 'string' ){ return }
    for (var key in response) {
      var list = response[key];

      if( list === null )
      continue;
      
      $(`.tags.${key}`).tagit( 'option', 'availableTags', list.sort((a,b) => { 
        return  a.localeCompare(b, 'en', {'sensitivity':'base'}); 
      }));
    }
  });
}

( () => {
  getFilters()

  const tagsElem = $('.tags')

  if( !tagsElem.length ){ return }
    
  bindEvents()

  $('.tags').not('.date').tagit({
    afterTagAdded: (event, ui) => { 
      $(ui.tag[0]).parent().prev('input').blur(); 
    },
    showAutocompleteOnFocus: true,
    allowSpaces: true,
  });

  $('.tags.date').datepicker({
    changeMonth: true,
    changeYear: true,
    yearRange: '1500:2030',
    dateFormat: 'dd/mm/yy'
  });
  $('.tags.date').datepicker($.datepicker.regional['pt-BR']);
  $('.tags.date').mask('99/99/9999');
})()